"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var language = {};
language.translations = {};
language.translations.options = {
  months: {
    1: 'Yanvar',
    2: 'Fevral',
    3: 'Mart',
    4: 'Aprel',
    5: 'May',
    6: 'İyun',
    7: 'İyul',
    8: 'Avqust',
    9: 'Sentyabr',
    10: 'Oktyabr',
    11: 'Noyabr',
    12: 'Dekabr'
  },
  shortMonths: {
    1: 'Yan',
    2: 'Fev',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'İyn',
    7: 'İyl',
    8: 'Avq',
    9: 'Sen',
    10: 'Okt',
    11: 'Noy',
    12: 'Dek'
  },
  weekdays: {
    1: 'Bazar ertəsi',
    2: 'Çərşənbə axşamı',
    3: 'Çərşənbə',
    4: 'Cümə axşamı',
    5: 'Cümə',
    6: 'Şənbə',
    7: 'Bazar'
  },
  shortWeekdays: {
    1: 'Be',
    2: 'Ça',
    3: 'Çər',
    4: 'Ca',
    5: 'Cüm',
    6: 'Şən',
    7: 'Baz'
  }
};
language.translations.global = {};
var _default = language;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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